import { MenuOption } from '@lexical/react/LexicalTypeaheadMenuPlugin';
import { SerializedTextNode } from 'lexical';

export type SerializedMentionNode = {
    mentionName: string;
    correlationId: string;
} & SerializedTextNode;

export class MentionTypeaheadOption extends MenuOption {
    name: string;

    type: string;

    id: number;

    picture: string;

    correlationId: string;

    constructor(name: string, type: string, id: number, picture: string, correlationId: string) {
        super(name);
        this.id = id;
        this.type = type;
        this.name = name;
        this.picture = picture;
        this.correlationId = correlationId;
    }
}

export type MentionPluginItem = Pick<MentionTypeaheadOption, 'name' | 'type' | 'id' | 'picture' | 'correlationId'>;
